import { Box, Button, Flex, Menu, Text, Title } from '@mantine/core';
import {
  IconBeach,
  IconMoneybag,
  IconPlus,
  IconTableExport,
} from '@tabler/icons';
import { User } from '../../../models/user';
import { WorkScale } from '../../../models/work-scale';
import { userRoleHumanized } from '../../../utils/constants/user';
import { BalanceText } from '../../../components/balance-text';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { formatSignedHours } from '../../../utils/helpers';

interface BankInfoProps {
  setPageModal: (value: 'pay-bank' | 'use-bank' | 'add-hours') => void;
  userInfo: User;
  workScale: WorkScale | undefined;
  amountBankHour: string;
  dailySeconds?: number;
  manualSeconds?: number;
}

export function BankInfo({
  userInfo,
  setPageModal,
  workScale,
  amountBankHour,
  dailySeconds,
  manualSeconds,
}: BankInfoProps) {
  const isMobile = useIsMobile();

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: '#FFF',
        padding: isMobile ? '20px' : '52px',
        borderRadius: theme.radius.md,
        boxShadow: theme.shadows.xs,
        transition: 'all 0.2s',
        marginBottom: '26px',

        '&:hover': {
          backgroundColor: '#fdfdfd1a',
        },
      })}
    >
      <Flex
        justify={'space-between'}
        gap={isMobile ? 'md' : 'xl'}
        w={'100%'}
        align={isMobile ? 'flex-start' : 'center'}
        direction={isMobile ? 'column' : 'row'}
      >
        <Box>
          <Text color="dimmed" size={'sm'}>
            Detalhes do Banco de Horas de
          </Text>
          <Title order={1}>{userInfo.username}</Title>
          <Flex gap={'xs'}>
            <Text color="dimmed" size={'sm'}>
              {userRoleHumanized[userInfo.role]}
            </Text>
            <Text color="dimmed" size={'sm'}>
              {workScale?.name}
            </Text>
          </Flex>
        </Box>
        <Box>
          <Text color="dimmed" size={'sm'}>
            Saldo atual
          </Text>
          {amountBankHour ? (
            <BalanceText value={amountBankHour} size="xl" />
          ) : (
            <Text fw="bold" size="xl">
              --
            </Text>
          )}
          {dailySeconds !== undefined && manualSeconds !== undefined && (
            <Box mt={8}>
              <Flex justify="space-between" gap="xl">
                <Text color="dimmed" size="xs">
                  Jornadas de trabalho
                </Text>
                <Text size="xs" fw={600}>
                  {formatSignedHours(dailySeconds)}
                </Text>
              </Flex>
              <Flex justify="space-between" gap="xl">
                <Text color="dimmed" size="xs">
                  Lançamentos manuais
                </Text>
                <Text size="xs" fw={600}>
                  {formatSignedHours(manualSeconds)}
                </Text>
              </Flex>
            </Box>
          )}
        </Box>
        <Flex align="center" justify="end">
          <Menu shadow="md" width={200}>
            <Menu.Target>
              <Button mr={8} rightIcon={<IconTableExport size={18} />}>
                Ações
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Label>Ações</Menu.Label>
              <Menu.Item
                icon={<IconPlus size={14} />}
                onClick={() => setPageModal('add-hours')}
              >
                Adicionar horas
              </Menu.Item>
              <Menu.Item
                icon={<IconMoneybag size={14} />}
                onClick={() => setPageModal('pay-bank')}
              >
                Pagar horas
              </Menu.Item>
              <Menu.Item
                icon={<IconBeach size={14} />}
                onClick={() => setPageModal('use-bank')}
              >
                Usar horas
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Flex>
      </Flex>
    </Box>
  );
}
